import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { MatDialogRef } from '@angular/material/dialog';
import { InitcontributionService } from '@tech-services/initcontribution.service';

@Component({
  selector: 'tech-modalriskwarning',
  templateUrl: './modalriskwarning.component.html',
  styleUrls: ['./modalriskwarning.component.scss'],
})
export class ModalriskwarningComponent implements OnInit {
  public form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<ModalriskwarningComponent>,
    private fb: UntypedFormBuilder,
    private initcontributionService: InitcontributionService
  ) {
    this.newform();
  }

  ngOnInit(): void {
    setTimeout(() => {
      // document.getElementById('initModal').focus();
    }, 3000);
  }

  public newform() {
    this.form = this.fb.group({
      iAgree: ['', [Validators.required]],
    });
  }

  goOut(): void {
    this.dialogRef.close();
  }

  goNext(): void {
    this.initcontributionService.agreeRiskWarningSource.next(true);
    this.dialogRef.close();
  }
}
